import React from "react";
import PropTypes from "prop-types";


class ArrayField extends React.Component {
    static EVENT_TYPES = {
        ADD: 'add',
        REMOVE: 'remove',
        CHANGE: 'change'
    };

    static propTypes = {
        name: PropTypes.string.isRequired,
        array: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired,
        children: PropTypes.func.isRequired,
        buildNewItem: PropTypes.func.isRequired,
        onInsertAfterItemCopy: PropTypes.func,
    };

    static key() {
        return Math.random().toString(16).slice(2);
    }

    static getDerivedStateFromProps(props, state) {
        // for the case when item is added not by clicking on 'add' button, but externally,
        // for example when adding the first item in a 'new' form in a componentDidMount
        if (state.keys.length < props.array.length) {
            const keys = [...state.keys];
            for (let i = keys.length; i < props.array.length; ++i)
                keys.push(ArrayField.key());
            return {keys};
        }
        return null;
    }

    state = {
        keys: this.props.array.map(ArrayField.key)
    }

    shouldComponentUpdate(nextProps) {
        return (nextProps.array !== this.props.array);
    }

    _onChange = (array, type) => {
        const ev = {target: {name: this.props.name, value: array}, type};
        this.props.onChange(ev);
    };

    onChange = (ev) => {
        const name = ev.target.name;
        const index = parseInt(name.slice(name.lastIndexOf('.') + 1), 10);
        const array = this.props.array.slice();
        array[index] = ev.target.value;
        this._onChange(array, ArrayField.EVENT_TYPES.CHANGE);
    };

    onRemove = (ev) => {
        const index = parseInt(ev.currentTarget.dataset.index, 10);
        const array = this.props.array.slice();
        array.splice(index, 1);

        const keys = [...this.state.keys];
        keys.splice(index, 1);
        this.setState({keys});

        this._onChange(array, ArrayField.EVENT_TYPES.REMOVE);
    };

    onInsert = (ev) => {
        const indexBefore = parseInt(ev.currentTarget.dataset.indexBefore, 10);
        let array = [
            ...this.props.array.slice(0, indexBefore),
            this.props.array[indexBefore],
            ...this.props.array.slice(indexBefore)
        ];

        if (this.props.onInsertAfterItemCopy)
            array = this.props.onInsertAfterItemCopy(array, indexBefore);

        const keys = [
            ...this.state.keys.slice(0, indexBefore),
            ArrayField.key(),
            ...this.state.keys.slice(indexBefore),
        ];

        this.setState({keys});
        this._onChange(array, ArrayField.EVENT_TYPES.REMOVE);
    }

    onAdd = () => {
        const array = this.props.array.slice();
        array.push(this.props.buildNewItem());

        const keys = [...this.state.keys];
        keys.push(ArrayField.key());
        this.setState({keys});

        this._onChange(array, ArrayField.EVENT_TYPES.ADD);
    };

    render() {
        // console.log('ArrayField render');
        const props = {
            name: this.props.name,
            array: this.props.array,
            keys: this.state.keys,
            onChange: this.onChange,
            onAdd: this.onAdd,
            onRemove: this.onRemove,
            onInsert: this.onInsert,
        };
        return this.props.children(props);
    }
}

export default ArrayField;